import { useMutation, useQueryClient } from "@tanstack/react-query";
import { confirmReport } from "../../api/reports";

export function useConfirmReport() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: confirmReport,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["reports"] });
    },
    onError: (err) => {
      console.error("Error confirming report:", err);
    },
  });
}